import { loaders } from '@graphql-cli/loaders';
export { loaders } from '@graphql-cli/loaders';

function parseGlobalArgs(args) {
    const headers = {};
    if (args.header) {
        args.header.forEach((header) => {
            const [name, ...values] = header.split(':');
            headers[name] = values.join('');
        });
    }
    if (args.require) {
        args.require.forEach((mod) => require(mod));
    }
    return { headers, token: args.token };
}
const createInspectorExtension = (name) => (api) => {
    loaders.forEach((loader) => {
        api.loaders.schema.register(loader);
    });
    loaders.forEach((loader) => {
        api.loaders.documents.register(loader);
    });
    return {
        name,
    };
};

export { createInspectorExtension, parseGlobalArgs };
//# sourceMappingURL=index.esm.js.map
